import React, { FC } from 'react';

interface Props {
  className?: string;
}

export const AppDarkIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      width="62"
      height="51"
      viewBox="0 0 62 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_646_1823)">
        <path d="M62 18.5315V11.9525C62 5.37818 56.6268 0 50.0586 0H16.4067L62 18.5315Z" fill="white" />
        <path
          d="M3.23779 47.1937C5.41949 49.5304 8.5137 51.0002 11.9414 51.0002H50.0539C56.6222 51.0002 61.9954 45.622 61.9954 39.0476V20.4233L3.23779 47.1937Z"
          fill="white"
        />
        <path
          d="M13.7248 0H11.9414C5.37318 0 0 5.37818 0 11.9525V39.0475C0 41.5372 0.773553 43.8554 2.08905 45.7748C24.8463 28.9124 28.7465 13.668 13.7248 0Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_646_1823">
          <rect width="62" height="51" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
